import request from '@/utils/request'

const prefix = '/django_rest/job-detail'

export default {
  searchCompanyJobList (params) {
    // const params = {
    //   keywords: null,
    //   type: null,
    //   job_industry_id: null,
    //   job_type_id: null,
    //   job_salary_id: null,
    //   job_work_time_id: null,
    //   role_type: null,
    //   c_lng: null,
    //   c_lat: null,
    //   order_by: null,
    //   area_city_id: null,
    //   area_region_id: null,
    //   area_id: null,
    //   only_referral: null,
    //   jtitle: null,
    //   company_id: companyId,
    //   page: 1
    // }
    // for nginx cache, this api is used by pc and mobile pages
    params.sp_var_device = 'mobile'
    return request.get('/search-company-jobs/', { params: params })
  },
  getCurrentCityByIp () {
    return request.get('/get-current-city-by-ip/')
  },
  getWorkLocationCitys (languageCode) {
    return request.get('/get-city-list/', { params: { language_code: languageCode } })
  },
  // has cache, special api for mobile job list page
  getSonIndustry () {
    return request.get('/django_rest/meta/job-types/')
  },
  // has cache, special api for mobile job list page
  getSonIndustryById (industryId) {
    return request.get(`/django_rest/meta/job-industries/${industryId}/job-types/`)
  },
  // has cache, special api for mobile job list page
  getParentIndustry () {
    return request.get('/django_rest/meta/job-industries/')
  },
  getJobRegions (cityId) {
    return request.get(`/trading-areas/cities/${cityId}/regions/`)
  },
  getJobAreas (regionId) {
    return request.get(`/trading-areas/region/${regionId}/areas/`)
  },
  unFollowCompany (companyId) {
    return request.post(`/remove-interest-company-confirm/${companyId}/`)
  },
  getSubmitInfoEncrypt (params) {
    const formData = new FormData()
    formData.set('submitInfo', params)
    return request.post('/submit-info/encrypt', formData)
  },
  getReferralEarnRewards (url) {
    return request.post(url)
  },
  getJobLocations (jobId, params) {
    return request.get(`/django_rest/job-locations/${jobId}/`, { params })
  },
  countShareTimes (params) {
    return request.get('/count-share-times/', { params })// job_id channel
  },
  getJobQrCode (jobId, shareUrl) {
    return request.get(`/job-qr-code/${jobId}/`, { params: { flag: 3, ref_url: shareUrl } })
  },
  getJobDetailJobPoster (params) {
    return request.get('/django_rest/get_job_poster/', { params })
  },
  getJobDetailInfoByShortId (shortId, params) {
    return request.get(`${prefix}/info/${shortId}/`, { params })
  },
  getJobReferralSetting (params) {
    return request.get(`${prefix}/referral-setting/`, { params })
  },
  getJobApplyStatus (params) {
    return request.get(`${prefix}/apply-status/`, { params })
  },
  getJobApplyAgreementInfo (params) {
    return request.get(`${prefix}/apply-agreement/`, { params })
  },
  getJobIndustryListWithJobType () {
    return request.get('/django_rest/job-industry/with-job-type/')
  },
  getJobSalaryList () {
    return request.get('/django_rest/meta/job-salary/')
  },
  getJobExperienceList () {
    return request.get('/django_rest/job-experience/')
  },
  getJobWorkTimeList () {
    return request.get('/django_rest/meta/job-work-time/')
  },
  addPotentialCandidates (params) {
    return request.post(`${prefix}/add-potential-candidates/`, params)
  },
  getJobListForPC (params) {
    return request.get('/django_rest/job-list/', { params })
  },
  getJobListFilter (params) {
    return request.get(`/django_rest/job-list/filter/${params.company_id}/`, { params })
  },
  getJobChannelAdditionalInfo (params) {
    return request.get('/django_rest/job-additional-info/', { params })
  },
  getJobCustomDescription (params) {
    return request.get(`${prefix}/custom-description/`, { params })
  },
  getTargetJobList (params) {
    const formData = new FormData()
    const candidateList = JSON.stringify(params.candidateList)
    formData.set('candidate_list', candidateList)

    return request.post('/get-target-job-list/', formData)
  },
  getJobInfo (jobId, params) {
    return request.get(`/django_rest/company/job/${jobId}/`, params)
  },
  getJobIdList (params) {
    return request.get('/django_rest/company/job-ids/', { params })
  },
  getJobCriterionList (params) {
    return request.get('/django_rest/company/job/criterion-list/', { params })
  },
  createJobCriterion (params) {
    return request.post('/django_rest/company/job/criterion-list/', params)
  },
  updateJobCriterion (params) {
    return request.put('/django_rest/company/job/criterion-list/', params)
  },
  createJobCriterionByParseJob (params) {
    return request.post('/django_rest/company/job/create-criterion/', params)
  },
  calculateJobCriterion (params) {
    return request.post('/django_rest/company/job/calculate-criterion/', params)
  }
}
